const base_url = "http://mini.kzp.bysjy.com.cn?role=seeker&is_sub=1&page="
const choose_url = "pages/choose/main?back="

export {
    base_url, choose_url
}


// WEBPACK FOOTER //
// ./src/datas/program.js